import { ConstConfig } from '../constants'

const QNImageUtil = {
  /**
   * 七牛图片格式化，参考：https://developer.qiniu.com/dora/1279/basic-processing-images-imageview2
   * @param {string} hash
   * @param {number} w
   * @param {number} h
   * @param {number} mode, 0 1 2 3 4 5
   * @param {string} format
   * @returns {string}
   */
  imageView: (hash, w, h, mode = 1, format = '') => {
    mode = mode || (mode === 0 ? 0 : 1)
    hash = hash || ''
    let url = ''
    // if (!hash) return ''
    if (!hash.match(/^(http|https):/i)) {
      url = ConstConfig.qiniuCdn + '/' + hash
    } else {
      const start = hash.indexOf('images.banmabang.cn')
      if (start > -1) {
        hash = hash.replace('images.banmabang.cn', 'images.snsports.cn')
      }
      url = hash
    }
    w = w || 0
    h = h || 0
    if (url.match(/images\.snsports\.cn/i) || url.match(/live\.snsports\.cn/i) || url.match(/live\.banmabang\.cn/i)) {
      if (url.indexOf('?') < 0) {
        if (mode == 0) {
            url = url + '?imageView2/' + mode
            if (w > 0) {
                url += '/w/' + w
            }
            if (h > 0) {
                url += '/h/' + h
            }
        }
        else {
            url = url + '?imageView2/' + mode + '/w/' + w + '/h/' + h
        }
        if (format) {
          url += '/format/' + format
          if (format === 'jpg') {
            url += '/interlace/1'
          }
        }
      }
    }
    return url
  },
  /**
   * @param {string} hash
   * @param {number} size, width and height equal
   * @param {number} mode, 0 1 2 3 4 5
   * @param {string} format
   * @returns {string}
   */
  iconView: (hash, size, mode, format) => {
    return QNImageUtil.imageView(hash, size, size, mode, format)
  },
  /**
   * @param {string} hash
   * @returns {string}
   */
  originView: hash => {
    let url = ''
    if (!hash) return ''
    if (!hash.match(/^(http|https):/i)) {
      url = ConstConfig.qiniuCdn + '/' + hash
    } else {
      url = hash
    }
    return url
  },
  imageView2: function (hash, w, h, mode, format) {
    // console.log('imageView2', arguments)
    mode = mode || 1
    let url = ''
    if (!hash) return false
    if (!hash.match(/^(http|https):/i)) {
      url = ConstConfig.qiniuCdn2 + '/' + hash
    } else {
      url = hash
    }
    if (url.match(/qiniucdn\.com/i) || url.match(/static\.bjh\.snsports\.cn/i) || url.match(/s\.bjhockey\.org/i) || url.match(/image\.bjh\.snsports\.cn/i)) {
      if (url.indexOf('?') < 0) {
        url = url + '?imageView2/' + mode + '/w/' + w + '/h/' + h
        if (format) {
          url += '/format/' + format
          if (format === 'jpg') {
            url += '/interlace/1'
          }
        }
      }
    }
    return url
  },
}

export { QNImageUtil }
